export enum GynecologicalEncounterQuestionnaireURLs {
  Encounter = "http://quiltedhealth.com/q/gynecological-encounter",
  VitalsSign = "http://quiltedhealth.com/q/gynecological-encounter-vitals-sign",
}

export enum GynecologicalEncounterDrawerActions {
  Save = "save",
  SignAndLock = "signAndLock",
}

export enum GynecologicalEncounterVitalsSignQuestionsLinkIds {
  GynecologicalGeneralAppearance = "gynecologicalVitalsGeneralAppearance",
  GynecologicalWeight = "gynecologicalVitalsWeight",
  GynecologicalWeightUnit = "gynecologicalVitalsWeightUnit",
  GynecologicalHeightUnit = "gynecologicalVitalsHeightUnit",
  GynecologicalHeightFeet = "gynecologicalVitalsHeightFeet",
  GynecologicalHeightInches = "gynecologicalVitalsHeightInches",
  GynecologicalHeightCm = "gynecologicalVitalsHeightCm",
  GynecologicalHeartRate = "gynecologicalVitalsHeartRate",
  GynecologicalRespiratoryRate = "gynecologicalVitalsRespiratoryRate",
  GynecologicalTemperature = "gynecologicalVitalsTemperature",
  GynecologicalTemperatureUnit = "gynecologicalVitalsTemperatureUnit",
  GynecologicalTemperatureMethod = "gynecologicalVitalsTemperatureMethod",
  GynecologicalNotes = "gynecologicalVitalsNotes",
  GynecologicalSystolicBP = "gynecologicalVitalsSystolicBP",
  GynecologicalDiastolicBP = "gynecologicalVitalsDiastolicBP",
}

export enum GynecologicalEncounterVitalsSignQuestionsDisplayNames {
  GynecologicalVitals = "Vitals",
  GynecologicalVitalsGeneralAppearance = "General Appearance",
  GynecologicalVitalsWeight = "Weight",
  GynecologicalVitalsHeight = "Height",
  GynecologicalVitalsHeartRate = "Heart Rate",
  GynecologicalVitalsRespiratoryRate = "Respiratory Rate",
  GynecologicalVitalsTemperature = "Temperature",
  GynecologicalVitalsMethod = "Method",
  GynecologicalVitalsNotes = "Notes",
  GynecologicalVitalsBpm = "bpm",
  GynecologicalVitalsTemperatureUnit = "F",
  GynecologicalVitalsSystolicBP = "Systolic BP",
  GynecologicalVitalsDiastolicBP = "Diastolic BP",
}

export enum VitalsDefaultUnitValues {
  TemperatureUnit = "F",
}

export enum GynecologicalEncounterQuestionsLinkIds {
  EncounterNote = "notes",
  EncounterTemplate = "encounterTemplate",
  EncounterType = "encounterType",
  EncounterLocation = "encounterLocation",
  EncounterAmendmentInfoReason = "encounterAmendmentInfoReason",
  EncounterAmendmentInfoSpecify = "encounterAmendmentInfoSpecify",
  EncounterAmendmentInfoNotes = "encounterAmendmentInfoNotes",
  EncounterAmendmentInfoNotifyClient = "encounterAmendmentInfoNotifyClient",
  EncounterDiagnosisCode = "encounterClientDiagnosisCode",
  EncounterDiagnosisAddToProblemList = "encounterClientDiagnosisAddToProblemList",
  EncounterDiagnosisNotes = "encounterClientDiagnosisNotes",
}

export const GYNECOLOGICAL_PHYSICAL_EXAMS = [
  "HEENTPhysicalExam",
  "GeneralAppearancePhysicalExam",
  "BreastPhysicalExam",
  "ExtremitiesPhysicalExam",
  "NeurologicPhysicalExam",
  "HeartPhysicalExam",
  "LungsPhysicalExam",
  "GenitourinaryPhysicalExam",
  "AbdomenPhysicalExam",
  "BackPhysicalExam",
  "SkinPhysicalExam",
  "PsychiatricPhysicalExam",
  "MusculoskeletalPhysicalExam",
  "NeckPhysicalExam",
  "PerineumAndExternalGenitaliaPhysicalExam",
] as const;
